import { createContext, useContext, useState } from "react";
import { CONTENT } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: CONTENT[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
